// Browser stand-in for fs-extra: the fs shim plus fs-extra's additions,
// routed through the FSA mount engine (fsa-core.cjs) where applicable.
// fs-extra returns promises when no callback is given, which is how the
// renderer's util/fs.ts consumes it.
const core = require("./fsa-core.cjs");
const fs = require("./fs.cjs");
const fsPromises = require("./fs-promises.cjs");

function enoent(filePath) {
    const err = new Error(
        `ENOENT: no such file or directory, web build has no filesystem '${String(filePath)}'`,
    );
    err.code = "ENOENT";
    err.errno = -2;
    err.path = String(filePath);
    return err;
}

module.exports = {
    ...fs,
    ...fsPromises,

    // fs-extra additions
    ensureDir: (p) => core.mkdir(p),
    ensureDirSync: () => undefined,
    ensureFile: async (p) => {
        const existing = await core.exists(p);
        if (existing !== true) {
            await core.writeFile(p, new Uint8Array());
        }
    },
    mkdirp: (p) => core.mkdir(p),
    mkdirpSync: () => undefined,
    emptyDir: (p) => core.rm(p).then(() => core.mkdir(p)),
    remove: (p) => core.rm(p),
    removeSync: () => undefined,
    copy: async (from, to) => {
        const data = await core.readFile(from).catch(() => null);
        if (data !== null && data !== core.NOT_HANDLED) {
            await core.writeFile(to, data);
        }
    },
    copySync: () => undefined,
    move: (from, to) => core.rename(from, to),
    moveSync: () => undefined,
    outputFile: (p, data) => core.writeFile(p, data),
    outputFileSync: () => undefined,
    outputJson: (p, value) => core.writeFile(p, JSON.stringify(value)),
    writeJson: (p, value) => core.writeFile(p, JSON.stringify(value)),
    writeJsonSync: () => undefined,
    readJson: (p) =>
        fsPromises.readFile(p, { encoding: "utf8" }).then((text) => {
            try {
                return JSON.parse(text);
            } catch (err) {
                throw Object.assign(
                    new Error(`invalid json in '${String(p)}': ${err.message}`),
                    { code: "EINVAL" },
                );
            }
        }),
    readJsonSync: (p) => {
        throw enoent(p);
    },
    pathExists: async (p) => {
        const result = await core.exists(p);
        return result === true;
    },
    pathExistsSync: () => false,

    constants: fs.constants,
    promises: fsPromises,
};
